import React from 'react';
import './PhotoGrid.css';

const PhotoGrid = ({ photos, onPhotoClick }) => {
  // Use static images mimicking the reference structure
  const staticPhotos = Array.from({ length: 8 }).map((_, i) => ({
    _id: `static-${i}`,
    url: `https://via.placeholder.com/400x400/1a1a1a/ff3333?text=Gallery+Image+${i + 1}`,
    caption: `Image ${i + 1}`
  }));

  const baseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'http://localhost:5001';
  const getImageUrl = (url) => url.startsWith('http') || url.startsWith('data:') ? url : `${baseUrl}${url}`;

  const displayPhotos = photos && photos.length > 0 ? photos.map(p => ({ ...p, fullUrl: getImageUrl(p.url) })) : staticPhotos.map(p => ({ ...p, fullUrl: getImageUrl(p.url) }));

  return (
    <div className="photo-grid-container">
      {/* Upload buttons removed from public view */}

      <div className="photo-grid">
        {displayPhotos.map((photo, index) => (
          <div
            key={photo._id}
            className="photo-item"
            style={{ animationDelay: `${index * 0.1}s` }}
            onClick={() => onPhotoClick && onPhotoClick(photo)}
          >
            <div className="photo-item-frame">
              <img src={photo.fullUrl} alt={photo.caption || 'Gallery photo'} />
              <div className="photo-overlay">
                <span className="plus-icon">+</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Upload buttons removed from public view */}
    </div>
  );
};

export default PhotoGrid;